<div #chatBox id="chatFrame" class="ui-resizable"
     [hidden]="localUser.accessType !== AccessType.STUDENT && classroom.isChatHidden"
     [style.height.px]="height"
     (keyup.enter)="sendMessage(studentInputMessage.value)"
     [ngClass]="{'open': !classroom.isChatCollapsed}" [ngStyle]="{'height': !classroom.isChatCollapsed ? '552px': '0'}">
  <div id="resizeButton" class="fas fa-expand-alt ui-resizable-handle ui-resizable-n doNotCloseChat"
       (mousedown)="startResize()">
  </div>
  <span id="OCButton" class="collapseButton" title="{{classroom.isChatCollapsed ? 'Expand Chat' : 'Collapse Chat'}}"
    [ngClass]="{'expandButton': classroom.isChatCollapsed, 'collapseButton': !classroom.isChatCollapsed}"
    (click)="toggleCollapseChat()">{{classroom.isChatCollapsed ? 'Expand' : 'Collapse'}}</span>
  <div id="resizableHandle">CHAT</div>
  <div id="textLog" #textLog>
    <div *ngFor="let message of (localUser.accessType === AccessType.STUDENT ? classroom.messages : classroom.classWideMassage)" class="message-wrap"
         [ngClass]="{'owner-teacher' : message.messageType === MessageType.TO_STUDENT || message.messageType === MessageType.TO_ALL,
                 'to-all': message.messageType === MessageType.TO_ALL,
                  'owner-me': message.messageType === MessageType.TO_STAFF && localUser.accessType === AccessType.STUDENT,
                  'owner-student': message.messageType === MessageType.TO_STAFF && localUser.accessType !== AccessType.STUDENT,
                  'owner-system': message.messageType === MessageType.SYSTEM}">
      <span class="msg-text" [ngClass]="{'m-correct': message.messageType === MessageType.TO_STUDENT && message.text === 'Correct',
                    'm-incorrect': message.messageType === MessageType.TO_STUDENT && message.text === 'Incorrect'}">
        <span class="msg-owner" *ngIf="message.messageType === MessageType.TO_ALL">
          <span *ngIf="message | isMessageFrom:AccessType.TEACHER">
            Teacher to All:
          </span>
          <span *ngIf="message | isMessageFrom:AccessType.SUPPORT">
            Support to All:
          </span>
        </span>
        <span class="msg-owner" *ngIf="message.messageType === MessageType.SYSTEM">SYSTEM</span>

        <span class="msg-owner" *ngIf="message.messageType === MessageType.TO_STUDENT">
          {{
          message.targetId === localUser.id ?
            (message | isMessageFrom:AccessType.TEACHER) ?
              'Teacher' :
            (message | isMessageFrom:AccessType.SUPPORT) ?
              'Support' :
              '' :
          'To ' + (remoteUsers[message.targetId] | fullName)
          }}
        </span>
        <span>{{message.text}}</span>
        <span class="msg-owner" *ngIf="message.messageType === MessageType.TO_STAFF">
          {{
          message.senderId === localUser.id ?
            'Me' :
            (remoteUsers[message.senderId] | fullName)
          }}
        </span>
      </span>
    </div>
  </div>

  <div id="inputContainer">
    <div *ngIf="showPopUp && localUser.accessType===AccessType.STUDENT"
         class="chat-box-notification alert-warning"> You have reached the limit of messages. Ask the teacher to clear the chat
    </div>
    <input #studentInputMessage
           id="chatInput"
           type="text"
           class="form-control "
           placeholder="Type here..."
           [(ngModel)]="inputValue"
           (ngModelChange)="onInputChange()"
           (copy)="utilService.safeCopy($event)"
           (cut)="utilService.safeCut($event)"
           (paste)="utilService.safePaste($event)">
    <button (click)="sendMessage(studentInputMessage.value)" id="chat_input_button" class="fas fa-share bottom " title="Send message"></button>
  </div>
</div>

